/**
 * Company Profile Page
 * Page wrapper for the company profile component
 */

import React from 'react';
import CompanyProfile from '../components/CompanyProfile';

/**
 * Company Profile Page Component
 * 
 * @returns {JSX.Element} Company profile page
 */
const CompanyProfilePage = () => {
  return <CompanyProfile />;
};

export default CompanyProfilePage;